import { Container } from '@mui/material';
import theme from 'assets';
import React from 'react';
import { Helmet } from 'react-helmet';


interface IPage {
  title: string
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
  children?: React.ReactNode
  className?: string
}

const Page = ({ title, children, className, maxWidth, ...rest }: IPage) => {
  return (
    <div {...rest} className={className}>
      <Helmet>
        {process.env.NODE_ENV === "production" &&
          <title>Athena OMS | {title}</title>
        }
        {process.env.NODE_ENV !== 'production' &&
          <title>Athena OMS {process.env.NODE_ENV} | {title}</title>
        }
      </Helmet>
      <Container maxWidth={maxWidth} sx={{ paddingTop: theme.spacing(2) }}>
        {children}
      </Container>
    </div>
  );
};

export default Page;
